// Maps each A.I. feature to the input device it needs. A vision feature is
// unusable without the camera; the voice feature is unusable without the
// microphone. Used to disable A.I. cards on Select Feature until their required
// input is chosen, and to explain why.
export const AI_INPUT_DEPENDENCY = {
    'ai/face': 'inputs/camera',
    'ai/motion': 'inputs/camera',
    'ai/color': 'inputs/camera',
    'ai/object': 'inputs/camera',
    'ai/pose': 'inputs/camera',
    'ai/gesture': 'inputs/camera',
    'ai/tracking': 'inputs/camera',
    'ai/ocr': 'inputs/camera',
    'ai/marker': 'inputs/camera',
    'ai/voice': 'inputs/microphone',
}

const INPUT_LABEL = {
    'inputs/camera': 'Camera',
    'inputs/microphone': 'Microphone',
    'inputs/keyboard': 'Keyboard',
    'inputs/mouse': 'Mouse',
}

// The input key an A.I. feature depends on, or null if it needs none.
export const requiredInputFor = (categorySlug, featureSlug) =>
    AI_INPUT_DEPENDENCY[`${categorySlug}/${featureSlug}`] || null

// Human label for a required input key.
export const inputLabel = (inputKey) => INPUT_LABEL[inputKey] || inputKey

// True when the feature's required input (if any) is present in `selected`.
export const dependencyMet = (categorySlug, featureSlug, selected) => {
    const req = requiredInputFor(categorySlug, featureSlug)
    return !req || selected.includes(req)
}
